import { GRAPH_NODE_MOVE, GRAPH_SESSION_PICK, GRAPH_SIGNAL_RESOLVED, GRAPH_TOOL_CALL, } from './graph-session.js';
import { PRE_GREETING_ROUTING } from './pre-greeting-routing.js';
import { PROPERTY_MATCH } from './property-match.js';
export const DECISION_DEFINITIONS = {
    [PRE_GREETING_ROUTING]: {
        displayName: 'Pre-greeting routing',
        highlights: {
            primary: ['outcome.chosenScenarioId', 'reason'],
            secondary: ['outcome.matchedScenarioIds', 'outcome.resolvedAgentId'],
        },
    },
    [PROPERTY_MATCH]: {
        displayName: 'Property match',
        highlights: {
            primary: ['reason', 'outcome.chosen.street'],
            secondary: ['inputs.query', 'outcome.isAmbiguous'],
        },
    },
    [GRAPH_SESSION_PICK]: {
        displayName: 'Graph or agent',
        highlights: {
            primary: ['reason', 'outcome.graphName'],
            secondary: [
                'inputs.channel',
                'inputs.candidateGraphIds',
                'outcome.agentId',
            ],
        },
    },
    [GRAPH_NODE_MOVE]: {
        displayName: 'Node move',
        highlights: {
            primary: ['outcome.toTitle', 'inputs.matched'],
            secondary: ['inputs.fromTitle', 'inputs.event', 'outcome.ended'],
        },
    },
    [GRAPH_SIGNAL_RESOLVED]: {
        displayName: 'Signal resolved',
        highlights: {
            primary: ['inputs.signal', 'outcome.typed'],
            secondary: ['inputs.nodeTitle', 'outcome.previous', 'inputs.raw'],
        },
    },
    [GRAPH_TOOL_CALL]: {
        displayName: 'Tool call',
        highlights: {
            primary: ['inputs.tool', 'inputs.args'],
            secondary: ['outcome.summary'],
        },
    },
};
//# sourceMappingURL=registry.js.map